import { render, staticRenderFns } from "./attributes.vue?vue&type=template&id=25543808&scoped=true&"
import script from "./attributes.vue?vue&type=script&lang=js&"
export * from "./attributes.vue?vue&type=script&lang=js&"
import style0 from "./attributes.vue?vue&type=style&index=0&id=25543808&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25543808",
  null
  
)

export default component.exports